<template>
  <div v-if="!isLoading">
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div class="mb-2">
          <h1 class="page-title align-items-center" title="">
            {{ $t('Bilan de société') + ' ' }}
            <b-button class="btn-medium ml-2" style="padding:5px !important;" variant="primary" @click="decrementYear">
              <chevron-left-icon size="14"/>
            </b-button>
            <b-button style="padding:5px !important;" variant="outline-primary">
              <span> {{
                  displayDateYear
                }}</span>
            </b-button>
            <b-button class="btn-medium" style="padding:5px !important;" variant="primary" @click="incrementYear">
              <chevron-right-icon size="14"/>
            </b-button>
            <b-icon id="info-circle-bilan" class="ml-2" icon="info-circle" variant="secondary"></b-icon>
            <b-tooltip html target="info-circle-bilan" variant="dark">
              Le bilan de société utlise les bilans EXE si existants, AVP sinon.
            </b-tooltip>
          </h1>

          <div class="page-information-date mt-2">
            <div>
              <span>{{
                $t('society.date.exercice.informations', {
                  startOfYear: new Date(this.startOfYear).toLocaleDateString('fr-FR', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  }), endOfYear: new Date(this.endOfYear).toLocaleDateString('fr-FR', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })
                })
              }}
            </span>
              <b-icon id="info-circle-date-comptable" class="ml-2 page-information-date" icon="info-circle" variant="secondary"></b-icon>
            </div>
            <div>
              <b-tooltip html target="info-circle-date-comptable" variant="dark">
                {{$t("society.date.exercice.tooltip")}}
              </b-tooltip>
            </div>
          </div>

        </div>

      </div>

      <div class="d-flex justify-content-between mb-3">
        <div style="width: 24%;">
          <card-component
            :value="Intl.NumberFormat().format((cardCa / 100).toFixed(0)) + ' €'"
            background-color="main-color"
            title="society.balance.sheet.card.title.CA"/>
        </div>
        <div style="width: 24%;">
          <card-component
            :charges-pro="Intl.NumberFormat().format((cardChargesPro / 100).toFixed(0))"
            :value="expenseValue() "
            background-color="main-color"
            title="society.balance.sheet.card.title.expense"/>
        </div>
        <div style="width: 24%;">
          <card-component
            :value="Intl.NumberFormat().format((cardEncaissement / 100).toFixed(0)) + ' €'"
            background-color="main-color"
            title="society.balance.sheet.card.title.encaissement"/>
        </div>
        <div style="width: 24%;">
          <card-component
            :value="Intl.NumberFormat().format((cardBenefice / 100).toFixed(0))  + ' €'"
            background-color="main-color"
            title="society.balance.sheet.card.title.benefice"/>
        </div>
      </div>

      <div>
        <b-card class="col-md-12 my-2">
          <div class="level-two-title secondary-color bold-text">
            {{ $t('society.balance.sheet.Marge') }}
          </div>

          <b-table id="table-field-operation" :fields="tableFieldsMarge" :items="itemsMarge"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-header'"
                   borderless
                   sort-icon-left
                   striped
                   style="margin-bottom: 0; line-height: 225%; vertical-align: middle;">
            <template #cell(lot)="data">
              <span v-html="data.value"></span>
            </template>
            <template #cell(acte)="data">
              <span v-html="data.value"></span>
            </template>
            <template #cell(vendu)="data">
              <span v-html="data.value"></span>
            </template>

          </b-table>

          <b-table id="table-total-operation" :fields="tableFieldsMarge"
                   :items="itemsTotalMarge"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-none'"
                   borderless
                   sort-icon-left
                   striped>
            <template #cell(operation)="data">
              <span>{{ $t(data.value) }}{{ $t(data.item.subtitle)}}</span>
            </template>
            <template #cell(tresoYear)="data">
              <div style="text-align: right"> {{ data.value }}</div>
            </template>
          </b-table>
        </b-card>
      </div>

      <div>
        <b-card class="col-md-12 my-2">
          <div class="level-two-title secondary-color bold-text">
            {{ $t('society.balance.sheet.Stock') }}
          </div>

          <b-table id="table-field-operation" :fields="tableFieldsStock" :items="itemsStock"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-header'"
                   borderless
                   sort-icon-left
                   striped
                   style="margin-bottom: 0;">
            <template #cell(lot)="data">
              <span v-html="data.value"></span>
            </template>
            <template #cell(date)="data">
              <span v-html="data.value"></span>
            </template>
          </b-table>

          <b-table id="table-total-operation" :fields="tableFieldsStock"
                   :items="itemsTotalStock"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-none'"
                   borderless
                   sort-icon-left
                   striped>
            <template #cell(name)="data">
              {{ $t(data.value) }}
            </template>
            <template #cell(price)="data">
              <div style="text-align: right"> {{ data.value }}</div>
            </template>
          </b-table>
        </b-card>
      </div>

      <div>
        <b-card class="col-md-12 my-2">
          <div class="level-two-title secondary-color bold-text">
            {{ $t('society.balance.sheet.Ventes') }}
          </div>

          <b-table id="table-field-ventes" :fields="tableFieldsVentes" :items="itemsVentes"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-header'"
                   borderless
                   sort-icon-left
                   striped
                   style="margin-bottom: 0;">
          </b-table>
          <b-table id="table-total-ventes" :fields="tableFieldsVentes"
                   :items="itemsTotalVentes"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-none'"
                   borderless
                   sort-icon-left
                   striped>
            <template #cell(name)="data">
              {{ $t(data.value) }}
            </template>
            <template #cell(price)="data">
              <div style="text-align: right"> {{ data.value }}</div>
            </template>
          </b-table>

        </b-card>
      </div>

      <div>
        <b-card class="col-md-12 my-2">
          <div class="level-two-title secondary-color bold-text">
            {{ $t('society.balance.sheet.Location') }}
          </div>

          <b-table id="table-field-location" :fields="tableFieldsLocation" :items="itemsLocation"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-header'"
                   borderless
                   sort-icon-left
                   striped
                   style="margin-bottom: 0;">
          </b-table>

          <b-table id="table-total-location" :fields="tableFieldsLocation"
                   :items="itemsTotalLocation"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-none'"
                   borderless
                   sort-icon-left
                   striped>
            <template #cell(name)="data">
              {{ $t(data.value) }}
            </template>
            <template #cell(price)="data">
              <div style="text-align: right"> {{ data.value }}</div>
            </template>
          </b-table>
        </b-card>
      </div>

      <div>
        <b-card class="col-md-12 my-2">
          <div class="level-two-title secondary-color bold-text">
            {{ $t('society.balance.sheet.Achat') }}
          </div>

          <b-table id="table-field-achat" :fields="tableFieldsAchat" :items="itemsAchat"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-header'"
                   borderless
                   sort-icon-left
                   striped
                   style="margin-bottom: 0;">
          </b-table>

          <b-table id="table-total-achat" :fields="tableFieldsAchat"
                   :items="itemsTotalAchat"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-none'"
                   borderless
                   sort-icon-left
                   striped>
            <template #cell(name)="data">
              {{ $t(data.value) }}
            </template>
            <template #cell(price)="data">
              <div style="text-align: right"> {{ data.value }}</div>
            </template>
          </b-table>

        </b-card>
      </div>

      <div>
        <b-card class="col-md-12 my-2">
          <div class="level-two-title secondary-color bold-text">
            {{ $t('society.balance.sheet.Charges.pro') }}
          </div>

          <b-table id="table-field-charges" :fields="tableFieldsCharges" :items="itemsCharges"
                   :sort-desc="true"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-header'"
                   borderless
                   sort-by="price"
                   sort-icon-left
                   striped
                   style="margin-bottom: 0;">
          </b-table>

          <b-table id="table-total-charges" :fields="tableFieldsCharges"
                   :items="itemsTotalCharges"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-none'"
                   borderless
                   sort-icon-left
                   striped>
            <template #cell(name)="data">
              {{ $t(data.value) }}
            </template>
            <template #cell(price)="data">
              <div style="text-align: right"> {{ data.value }}</div>
            </template>
          </b-table>
        </b-card>
      </div>
      <div>
        <b-card class="col-md-12 my-2">
          <div class="level-two-title secondary-color bold-text">
            {{ $t('society.balance.sheet.new.investor') }}
          </div>

          <b-table id="table-field-new-investor" :fields="tableFieldsNewInvestor" :items="itemsContrat"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-header'"
                   borderless
                   sort-icon-left
                   striped
                   style="margin-bottom: 0;">

          </b-table>


          <b-table id="table-total-versements" :fields="tableFieldsNewInvestor"
                   :items="itemsTotalContrat"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-none'"
                   borderless
                   sort-icon-left
                   striped>
            <template #cell(contrat)="data">
              {{ $t(data.item.contrat) }}
            </template>

            <template #cell(initialPayment)="data">
              <div style="text-align: right"> {{ data.item.initialPayment + ' ' + '€' }}</div>
            </template>

          </b-table>
        </b-card>
      </div>
    </b-container>
  </div>

</template>

<script>

import CardComponent from "../../components/b122/CardComponent";
import api from "../../services/api";

export default {
  name: "SocietyBalanceSheetIndex",

  components: {
    CardComponent
  },

  data() {
    return {
      dateComptable: null,
      isLoading: false,
      year: null,
      startOfYear: null,
      endOfYear: null,

      cardCa: 0,
      cardChargesPro: 0,
      cardInterest: 0,
      cardEncaissement: 0,
      cardApportTreso: 0,
      cardBenefice: 0,

      // LOCATION
      tableFieldsLocation: [
        {
          label: 'Opération - Lot',
          key: 'name',
          thStyle: {width: "30%"},
          sortable: true,
        },
        {
          label: 'Bilan',
          key: 'bilanType',
          thStyle: {width: "10%"},
          sortable: false,
        },
        {
          label: 'Début',
          key: 'dateDebut',
          thStyle: {width: "15%"},
          sortable: true,
          formatter: function (value) {
            return value != null ? new Date(value).toLocaleDateString() : null
          }
        },
        {
          label: 'Fin',
          key: 'dateFin',
          thStyle: {width: "15%"},
          sortable: true,
          formatter: function (value) {
            return value != null ? new Date(value).toLocaleDateString() : null
          }
        },
        {
          label: 'Durée',
          key: 'duree',
          thStyle: {width: "10%"},
          sortable: true,
        },
        {
          label: 'Loyers',
          key: 'price',
          thStyle: {width: "20%"},
          sortable: true,
          formatter: function (value) {
            return value + " €"
          }
        }
      ],
      itemsLocation: [],
      itemsTotalLocation: [],

      // VENTES
      tableFieldsVentes: [
        {
          label: 'Opération',
          key: 'name',
          thStyle: {width: "30%"},
          sortable: true,
        },
        {
          label: 'Bilan',
          key: 'bilanType',
          thStyle: {width: "10%"},
          sortable: false,
        },
        {
          label: 'Lot',
          key: 'lot',
          thStyle: {width: "25%"},
          sortable: true,
        },
        {
          label: 'Date',
          key: 'date',
          thStyle: {width: "15%"},
          sortable: true,

          formatter: function (value) {
            return value != null ? new Date(value).toLocaleDateString() : null
          }
        },
        {
          label: 'Prix',
          key: 'price',
          thStyle: {width: "20%"},
          sortable: true,

          formatter: function (value) {
            return value + " €"
          }
        }
      ],
      itemsVentes: [],
      itemsTotalVentes: [],

      // ACHAT
      tableFieldsAchat: [
        {
          label: 'Nom',
          key: 'name',
          thStyle: {width: "65%"},
          sortable: true,
        },
        {
          label: 'Bilan',
          key: 'bilanType',
          thStyle: {width: "10%"},
          sortable: false,
        },
        {
          label: 'Date',
          key: 'date',
          thStyle: {width: "15%"},
          sortable: true,

          formatter: function (value) {
            return value != null ? new Date(value[0]).toLocaleDateString() : ''
          }
        },
        {
          label: 'Prix',
          key: 'price',
          thStyle: {width: "20%"},
          sortable: true,

          formatter: function (value) {
            return value + " €"
          }
        }
      ],
      itemsAchat: [],
      itemsTotalAchat: [],

      // OPERATIONS
      tableFieldsMarge: [
        {
          label: 'Nom opération',
          key: 'operation',
          thStyle: {width: "20%"}, tdClass: 'align-middle',
          sortable: true,
        },
        {
          label: 'Bilan',
          key: 'bilanType',
          thStyle: {width: "5%"}, tdClass: 'align-middle',
          sortable: false,
        },
        {
          label: 'Lot / échéance',
          key: 'lot',
          thStyle: {width: "25%"},
          sortable: true,
        },
        {
          label: 'Acte',
          key: 'acte',
          thStyle: {width: "12%"},
          sortable: false,
        },
        {
          label: "Lots vendus",
          key: 'vendu',
          thStyle: {width: "10%"},
          sortable: true,
        },
        {
          label: "Marge de l'opération",
          key: 'marge',
          thStyle: {width: "14%"}, tdClass: 'align-middle',
          sortable: true,

          formatter: function (value) {
            return value != null ? value + " €" : null
          }
        },
        {
          label: "Encaissement",
          key: 'tresoYear',
          thStyle: {width: "14%"}, tdClass: 'align-middle',
          sortable: true,

          formatter: function (value) {
            return value != null ? value + " €" : null
          }
        }
      ],
      itemsMarge: [],
      itemsTotalMarge: [],

      // STOCK
      tableFieldsStock: [
        {
          label: 'Opération',
          key: 'name',
          thStyle: {width: "30%"},
          sortable: true,
        },
        {
          label: 'Bilan',
          key: 'bilanType',
          thStyle: {width: "10%"},
          sortable: false
        },
        {
          label: 'Lot',
          key: 'lot',
          thStyle: {width: "25%"},
          sortable: true,
        },
        {
          label: 'Date',
          key: 'date',
          thStyle: {width: "15%"},
          sortable: false,
        },
        {
          label: 'Prix',
          key: 'price',
          thStyle: {width: "20%"},
          sortable: true,

          formatter: function (value) {
            return value != null ? value + " €" : null
          }
        }
      ],
      itemsStock: [],
      itemsTotalStock: [],

      // CHARGES
      tableFieldsCharges: [
        {
          label: 'Type',
          key: 'name',
          thStyle: {width: "85%"},
          sortable: true,
        },
        {
          label: 'Montant HT',
          key: 'price',
          thStyle: {width: "15%"},
          sortable: true,

          formatter: function (value) {
            return value + " €"
          }
        }
      ],
      itemsCharges: [],
      itemsTotalCharges: [],

      // VERSEMENTS
      tableFieldsVersement: [
        {
          label: 'Contrat',
          key: 'contrat',
          thStyle: {width: "55%"},
          sortable: true,
        },
        {
          label: 'Bilan',
          key: 'bilanType',
          thStyle: {width: "10%"},
          sortable: false,
        },
        {
          label: 'Versé le',
          key: 'date',
          thStyle: {width: "15%"},
          sortable: true,

          formatter: function (value) {
            return value != null ? new Date(value).toLocaleDateString() : '';
          }
        },
        {
          label: 'Montant',
          key: 'versement',
          thStyle: {width: "20%"},
          sortable: true,

          formatter: function (value) {
            return value + " €"
          }
        },
      ],
      itemsVersement: [],
      itemsTotalInterest: [],


      // NEW INVESTOR
      tableFieldsNewInvestor: [
        {
          label: this.$t('contrat.Name'),
          key: 'contrat',
          sortable: true
        },
        {
          label: this.$t('Bilan'),
          key: 'bilanType',
          sortable: true
        },
        {
          label: this.$t('contrat.date'),
          key: 'datePayment',
          sortable: true,
          formatter: function (value) {
            if (value == null)
              return ''
            return new Date(value).toLocaleDateString()
          }
        },
        {
          label: this.$t('contrat.rendement'),
          key: 'rendement',
          sortable: true,
          formatter: function (value) {
            if (value == null)
              return ''
            return value.toString() + " %"
          }
        },
        {
          label: this.$t('contrat.interests'),
          key: 'interests',
          sortable: false,
          formatter: function (value) {
            if (value == null)
              return ''
            return Intl.NumberFormat().format((value / 100).toFixed(2)) + " €"
          }
        },
        {
          label: this.$t('contrat.deadline'),
          key: 'deadline',
          sortable: true,
          formatter: function (value) {
            if (value == null)
              return ''
            return new Date(value).toLocaleDateString()
          }
        },
        {
          label: this.$t('contrat.capital'),
          key: 'initialPayment',
          sortable: true,
          formatter: function (value) {
            if (value == null)
              return ''
            return Intl.NumberFormat().format((value / 100).toFixed(2)) + " €"
          }
        },
      ],

      itemsContrat: [],
      itemsTotalContrat: []
    }
  },

  watch: {
    year: async function () {
      if (this.dateComptable) {
        const comptableDate = new Date(this.dateComptable);
        const startOfYear = new Date(this.year, comptableDate.getMonth(), comptableDate.getDate()).getTime();
        const endOfYear = new Date(this.year + 1, comptableDate.getMonth(), comptableDate.getDate() - 1).getTime();

        this.startOfYear = startOfYear;
        this.endOfYear = endOfYear;
      } else {
        this.startOfYear = new Date(this.year, 0, 1).getTime();
        this.endOfYear = new Date(this.year + 1, 0, 1).getTime() - 24 * 60 * 60 * 1000;
      }

      await this.fetchData();
    },
    dateComptable: async function () {
      if (this.dateComptable) {
        const comptableDate = new Date(this.dateComptable);
        const startOfYear = new Date(this.year, comptableDate.getMonth(), comptableDate.getDate()).getTime();
        const endOfYear = new Date(this.year + 1, comptableDate.getMonth(), comptableDate.getDate() - 1).getTime();

        this.startOfYear = startOfYear;
        this.endOfYear = endOfYear;
      } else {
        this.startOfYear = new Date(this.year, 0, 1).getTime();
        this.endOfYear = new Date(this.year + 1, 0, 1).getTime() - 24 * 60 * 60 * 1000;
      }

      await this.fetchData();
    },
    cardEncaissement : function () {
      this.cardBenefice = (this.cardEncaissement ? this.cardEncaissement : 0) - (this.cardChargesPro ? this.cardChargesPro : 0)
    },
    cardChargesPro : function () {
      this.cardBenefice = (this.cardEncaissement ? this.cardEncaissement : 0) - (this.cardChargesPro ? this.cardChargesPro : 0)
    },
  },


  created() {
    this.setYear()
  },

  computed: {
    displayDateYear() {
      const startYear = new Date(this.startOfYear).getFullYear();
      const endYear = new Date(this.endOfYear).getFullYear();

      return startYear === endYear ? `${startYear}` : `${startYear}/${endYear}`;
    }
  },

  methods: {
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.status === 'title-section') return 'row-title-section'
      else if (item.status === 'total-primary') return 'row-total-primary'
      else if (item.status === 'total-grey') return 'row-total-grey'
      else if (item.status === 'subtitle') return 'bold-text main-red-color'
    },

    decrementYear() {
      this.year--
    },

    setYear() {
      this.year = new Date().getFullYear()
    },

    incrementYear() {
      this.year++
    },

    async fetchData() {
      this.isLoading = true
      await this.fetchDateComptable()
      await this.fetchVentes()
      await this.fetchAchat()
      await this.fetchOperations()
      await this.fetchStock()
      await this.fetchChargesPro()
      await this.fetchVersement()
      await this.fetchNewInvestor()
      await this.fetchLocation()
      console.log(this.cardEncaissement)
      console.log(this.cardChargesPro)
      this.cardBenefice = (this.cardEncaissement ? this.cardEncaissement : 0) - (this.cardChargesPro ? this.cardChargesPro : 0)
      this.isLoading = false
    },

    async fetchLocation() {
      let dataLocation = new FormData()
      dataLocation.append('startOfYear', this.startOfYear)
      dataLocation.append('endOfYear', this.endOfYear)

      api({
        method: 'POST',
        url: `/balanceSheet/getAllLocationsByYear`,
        data: dataLocation
      })
        .then(response => {
          this.itemsLocation = response.data['itemsLocation']
          this.itemsTotalLocation = response.data['itemsTotalLocation']
        })
    },

    async fetchDateComptable() {
      await api
        .get(`/user/getProfile`)
        .then(async response => {
          this.dateComptable = response.data['dateComptable']
        })
    },

    async fetchVentes() {
      let dataVentes = new FormData()
      dataVentes.append('startOfYear', this.startOfYear)
      dataVentes.append('endOfYear', this.endOfYear)

      api({
        method: 'POST',
        url: `/balanceSheet/getAllSalesByYear`,
        data: dataVentes
      })
        .then(response => {
          this.itemsVentes = response.data['itemsVentes']
          this.itemsTotalVentes = response.data['itemsTotalVentes']
          this.cardCa = response.data['totalVentes']
        })
    },

    async fetchAchat() {
      let dataAchats = new FormData()
      dataAchats.append('startOfYear', this.startOfYear)
      dataAchats.append('endOfYear', this.endOfYear)

      api({
        method: 'POST',
        url: `/balanceSheet/getAllAchatsByYear`,
        data: dataAchats
      })
        .then(response => {
          this.itemsAchat = response.data['itemsAchat']
          this.itemsTotalAchat = response.data['itemsTotalAchat']
        })
    },

    async fetchOperations() {
      let dataOperations = new FormData()
      dataOperations.append('year', this.year)
      dataOperations.append('startOfYear', this.startOfYear)
      dataOperations.append('endOfYear', this.endOfYear)

      api({
        method: 'POST',
        url: `/balanceSheet/getAllOperationsByYear`,
        data: dataOperations
      })
        .then(response => {
          this.itemsMarge = response.data['itemsMarge']
          this.itemsTotalMarge = response.data['itemsTotalMarge']
          this.cardApportTreso = response.data['treso']
          this.cardEncaissement = response.data['cardEncaissement']
        })
    },

    async fetchStock() {
      let dataStock = new FormData()
      dataStock.append('startOfYear', this.startOfYear)
      dataStock.append('endOfYear', this.endOfYear)

      api({
        method: 'POST',
        url: `/balanceSheet/getAllStockByYear`,
        data: dataStock
      })
        .then(response => {
          this.itemsStock = response.data['itemsStock']
          this.itemsTotalStock = response.data['itemsTotalStock']
        })
    },

    async fetchChargesPro() {
      let dataChargesPro = new FormData()
      dataChargesPro.append('startOfYear', this.startOfYear)
      dataChargesPro.append('endOfYear', this.endOfYear)

      api({
        method: 'POST',
        url: `/balanceSheet/getAllChargesProByYear`,
        data: dataChargesPro
      })
        .then(response => {
          this.itemsCharges = response.data['itemsCharges']
          this.itemsTotalCharges = response.data['itemsTotalCharges']
          this.cardChargesPro = response.data['totalChargesPro']
        })
    },

    async fetchVersement() {
      let dataChargesPro = new FormData()
      dataChargesPro.append('startOfYear', this.startOfYear)
      dataChargesPro.append('endOfYear', this.endOfYear)

      api({
        method: 'POST',
        url: `/balanceSheet/getAllVersementByYear`,
        data: dataChargesPro
      })
        .then(response => {
          this.itemsVersement = response.data['itemsVersement']
          this.itemsTotalInterest = response.data['itemsTotalVersements']
          this.cardInterest = response.data['totalVersement']
        })
    },

    async fetchNewInvestor() {
      let data = new FormData()
      data.append('startOfYear', this.startOfYear)
      data.append('endOfYear', this.endOfYear)

      api({
        method: 'POST',
        url: `/balanceSheet/getAllNewInvestorByYear`,
        data: data
      })
        .then(response => {
          this.itemsContrat = response.data['itemsContrat']
          this.itemsTotalContrat = response.data['itemsTotalContrat']
          this.totalContrat = response.data['totalContrat']
        })
    },

    expenseValue() {
      let total = Number((this.cardChargesPro / 100).toFixed(0))
      return Intl.NumberFormat().format(total) + '€'
    }

  }
}
</script>

<style scoped>
.page-information-date {
  font-family: Montserrat-Bold, "Arial", sans-serif;
  color: var(--tertiary-text-color)!important;
}

.total-operation-subtitle{
  text-transform: lowercase;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/societyBalanceSheet/SocietyBalanceSheetIndex.vue